const misc = document.createElement('div');
const dragGhost = document.createElement('div');
const dragGhostText = document.createElement('div');
const dragGhostPointer = document.createElement('div');
const chromeVersion = getChromeVersion();
dragGhostText.className = 'ucd-dragGhost-text';
dragGhostPointer.className = 'ucd-dragGhost-pointer';
dragGhost.appendChild(dragGhostText);
dragGhost.appendChild(dragGhostPointer);
dragGhost.className = 'ucd-dragGhost';
misc.style.cssText = 'width:1px;height:0;opacity:0;position:absolute;left:0;';
// 这个是用于拖拽时的那个半透明的残影（系统）
export function getDragGhost(text) {
  dragGhostText.textContent = text;
  misc.appendChild(dragGhost);
  document.body.appendChild(misc);
  return dragGhost;
}
export function useDragGhost(ev, text) {
  var _ev$dataTransfer;
  const dragGhost = getDragGhost(text);
  const getOffset = () => {
    if (chromeVersion < 98 || chromeVersion >= 104) {
      // 兼容旧chrome的setDragImage不计入dpr
      return {
        xOffset: dragGhost.offsetWidth / 2,
        yOffset: dragGhost.offsetHeight - 8
      };
    }
    return {
      xOffset: dragGhost.offsetWidth / 2 * devicePixelRatio,
      yOffset: (dragGhost.offsetHeight - 8) * devicePixelRatio
    };
  };
  const {
    xOffset,
    yOffset
  } = getOffset();
  (_ev$dataTransfer = ev.dataTransfer) === null || _ev$dataTransfer === void 0 || _ev$dataTransfer.setDragImage(dragGhost, xOffset, yOffset);
  const free = () => {
    dragGhost.removeEventListener('mouseenter', free, true);
    document.body.removeEventListener('dragend', free, true);
    document.body.removeEventListener('drop', free, true);
    freeDragGhost();
  };
  dragGhost.addEventListener('mouseenter', free, true);
  document.body.addEventListener('dragend', free, true);
  document.body.addEventListener('drop', free, true);
}
export function freeDragGhost() {
  var _misc$parentElement;
  (_misc$parentElement = misc.parentElement) === null || _misc$parentElement === void 0 || _misc$parentElement.removeChild(misc);
}
function getChromeVersion() {
  const ua = navigator.userAgent.toLowerCase();
  const match = ua.match(/\bchrome\/(\d+)/);
  // 目前只有chrome<98会出问题 safari没问题就先Infinity了
  return match ? parseInt(match[1], 10) : Infinity;
}
//# sourceMappingURL=DragGhost.js.map
